export default "__VITE_ASSET__2V$gBxfP__"